function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "arrow-left_inline_svg__Icon_material-arrow-forward",
  "data-name": "Icon material-arrow-forward",
  d: "M15.932 6l1.75 1.75-6.927 6.94h15.108v2.483H10.755l6.927 6.94-1.75 1.75L6 15.932z",
  transform: "translate(-6 -6)",
  fill: "#02e9b8"
});

function SvgArrowLeftinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.863,
    height: 19.863,
    viewBox: "0 0 19.863 19.863"
  }, props), _ref);
}

export default SvgArrowLeftinline;